import { useFormik, FormikProvider } from "formik";
import { Button } from "primereact/button";
import {
  StudentInfoAdminResponse,
  StudentSemesterAttestationRequest,
  StudentSemesterAttestationResponse,
} from "../../models/dtos";
import { studentsApi } from "../../services/students/studentsApi";
import { academicYearsApi } from "../../services/nomenclatures/academicYearsApi";
import SemesterAttestationFormFields from "./SemesterAttestationFormFields";

interface SemesterAttestationFormProps {
  student: StudentInfoAdminResponse;
  onSuccess?: () => void;
  initialValues?: StudentSemesterAttestationResponse;
}

type FormValues = {
  semester: number;
  academicYearId: number | null;
  attestationDate: Date | null;
  semesterAttestationTypeId: number | null;
};

const SemesterAttestationForm = ({ student, onSuccess, initialValues }: SemesterAttestationFormProps) => {
  const [addAttestation] = studentsApi.useAddStudentSemesterAttestationMutation();
  const [updateAttestation] = studentsApi.useUpdateStudentSemesterAttestationMutation();
  const { data: currentAcademicYear } = academicYearsApi.useGetCurrentAcademicYearIdQuery();

  const formik = useFormik<FormValues>({
    initialValues: initialValues
      ? {
          semester: initialValues.semester,
          academicYearId: initialValues.academicYearId,
          attestationDate: initialValues.attestationDate ? new Date(initialValues.attestationDate) : null,
          semesterAttestationTypeId: initialValues.semesterAttestationTypeId,
        }
      : {
          semester: student.semester,
          academicYearId: currentAcademicYear?.data ?? null,
          attestationDate: null,
          semesterAttestationTypeId: null,
        },
    enableReinitialize: true,
    onSubmit: async (values) => {
      const attestationData: StudentSemesterAttestationRequest = {
        studentSemesterAttestationId: initialValues?.studentSemesterAttestationId ?? 0,
        studentId: student.studentId,
        semester: values.semester,
        academicYearId: values.academicYearId ?? currentAcademicYear?.data ?? 0,
        attestationDate: values.attestationDate,
        semesterAttestationTypeId: values.semesterAttestationTypeId ?? 0,
      };

      if (initialValues) {
        await updateAttestation(attestationData);
      } else {
        await addAttestation(attestationData);
      }
      formik.resetForm();
      onSuccess?.();
    },
  });

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit} className="flex gap-3 align-items-center justify-content-start">
        <SemesterAttestationFormFields />
        <div className="col-2">
          <Button label={initialValues ? "Запази" : "Добави"} type="submit" />
        </div>
      </form>
    </FormikProvider>
  );
};

export default SemesterAttestationForm;
